import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Currency } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  UpdateUserSettingsRewardCurrencyMutation,
  UpdateUserSettingsRewardCurrencyMutationVariables,
} from './__generated__/useUpdateRewardCurrency.graphql.ts';

const UPDATE_USER_SETTINGS_REWARD_CURRENCY_MUTATION = gql`
  mutation UpdateUserSettingsRewardCurrencyMutation(
    $input: updateUserSettingsInput!
  ) {
    updateUserSettings(input: $input) {
      userSettings {
        id
        rewardCurrency
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserSettingsRewardCurrencyMutation,
  UpdateUserSettingsRewardCurrencyMutationVariables
>;

export const useUpdateRewardCurrency = () => {
  const { currentUser } = useCurrentUserContext();
  const [mutateRewardCurrency, { loading }] = useMutation(
    UPDATE_USER_SETTINGS_REWARD_CURRENCY_MUTATION,
    { showErrorsWithSnackNotification: true }
  );

  const updateRewardCurrency = (rewardCurrency: Currency) => {
    mutateRewardCurrency({
      variables: {
        input: {
          rewardCurrency,
        },
      },
      optimisticResponse: {
        updateUserSettings: {
          __typename: 'updateUserSettingsPayload',
          userSettings: {
            ...currentUser!.userSettings,
            rewardCurrency,
          },
          errors: [],
        },
      },
    });
  };

  return {
    updateRewardCurrency,
    loading,
  };
};
